import { Component, OnInit } from '@angular/core';
import { ScreenSize, DeviceInfo } from 'src/app/models';
import { GenericService } from 'src/app/generic.service';

@Component({
  selector: 'app-lander',
  templateUrl: './lander.component.html',
  styles: [
  ]
})
export class LanderLayoutComponent {
  size = new ScreenSize();
  device = new DeviceInfo();
  constructor(private service: GenericService) {
    this.size = this.service.size;
    this.device = this.service.device;
  }

}
